import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthStatus } from '@shared/models/auth/auth.model';
import { AuthService } from '../services/auth.service';
import { PlatformService } from 'src/app/shared/services/platform.service';
@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

  constructor(
    private authService: AuthService,
    private router: Router,
    private platformService: PlatformService,
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {

    const canActivate: boolean = this.authService.isAuthenticated() !== AuthStatus.ALL_TOKENS_INVALID;

    if (!canActivate) {
      const target = this.platformService.isNativeApp ? 'auth/login' : 'inicio';
      this.router.navigate([target], { queryParams: { redirectUrl: state.url } });
    }

    return canActivate;
  }
}
